module.exports = __webpack_public_path__ + "media/images/workplace/social-ico/google-ico-a675bcd3192c56cb20fce1d3a80346d6.svg";